import { CMaterialType } from '@chamn/model';
import { snippets } from './snippets';

export const HeaderMeta: CMaterialType = {
  componentName: 'Header',
  title: '页顶',
  props: [],
  npm: {
    name: 'Header',
    package: __PACKAGE_NAME__ || '',
    version: __PACKAGE_VERSION__,
    destructuring: true,
    exportName: 'Header',
  },
  snippets: snippets,
};

export default [HeaderMeta];

export type A = string;
